module.exports = "/_next/static/images/cardImage3-d344433a969e0d8457532e1eb0f208d7.webp";